import { render } from "./Subjects.vue?vue&type=template&id=1f6a7789&scoped=true"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"

import "./Subjects.vue?vue&type=style&index=0&id=1f6a7789&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a7789"]])

export default __exports__